import { compactObject } from '@masterplandev/utils'

export const createRequestAction =
  (url, method = 'GET', params = {}) =>
  (data?: any) => ({ request: compactObject({ url, method, ...params, data }) })

export default createRequestAction
